import { useQuery } from "react-query";
import { API_KEY_GET_MANAGEABLE_NOTIFICATION } from "../constants";
import { getNotification } from "../api";

export const useGetNotification = (id) => {
  return useQuery([API_KEY_GET_MANAGEABLE_NOTIFICATION, id], () =>
    getNotification(id)
  );
};
